import { useEffect } from 'react';

const useCalculateCredit = (mnyRqust: string, trmInDys: string) => {
  if (parseInt(mnyRqust) > 0 || parseInt(trmInDys) > 0) {
    return {
      mnyRqust: parseInt(mnyRqust),
      trmInDys: parseInt(trmInDys)
    };
  } else {
    return {
      mnyRqust: 0,
      trmInDys: 0
    };
  }
};

export default useCalculateCredit;
